(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      const format =
        window.omalleyMoneyFormat ||
        (typeof theme !== 'undefined' && theme.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function tierUnitPrice(baseCents, percentOff) {
    if (!percentOff) return baseCents;
    return Math.round((baseCents * (100 - percentOff)) / 100);
  }

  function updateVolumeTable(wrap, variant) {
    const configEl = wrap.querySelector('[data-omalley-volume-config]');
    if (!configEl || !variant?.price) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (_error) {
      return;
    }

    const baseCents = variant.price;
    const showWholesale = config.isWholesaleCustomer && config.wholesaleEnabled;
    const wholesaleMultiplier = config.wholesaleMultiplier ?? 100;

    wrap.querySelectorAll('[data-omalley-tier-row]').forEach((row) => {
      const percentOff = parseFloat(row.dataset.percentOff || '0');
      const retailCents = tierUnitPrice(baseCents, percentOff);
      const displayCents = showWholesale
        ? Math.round((retailCents * wholesaleMultiplier) / 100)
        : retailCents;

      const retailEl = row.querySelector('[data-omalley-tier-retail]');
      const displayEl = row.querySelector('[data-omalley-tier-display]');

      if (retailEl) retailEl.textContent = formatMoney(retailCents);
      if (displayEl) displayEl.textContent = formatMoney(displayCents);
    });
  }

  function handleVariantChange({ data }) {
    if (!data?.variant || !data.sectionId) return;

    const wrap = document.getElementById(`Wholesale-Volume-${data.sectionId}`);
    if (wrap) updateVolumeTable(wrap, data.variant);
  }

  subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
})();
